import { replace } from 'react-router-dom';
import { fetchCabinetStatus } from '@/pages/Cabinet/api/requests';
import { CabinetStatuses } from '@/pages/Cabinet/types';
import { fetchNotifications } from '@/pages/Notifications/api/requests';

export const cabinetLoader = async () => {
  const token = localStorage.getItem('token');
  if (!token) {
    return replace('/auth', { status: 301 });
  }

  const notificationsResponse = await fetchNotifications(token);
  if (notificationsResponse?.data.length) {
    return replace('/notifications', { status: 301 });
  }

  const cabinetResponse = await fetchCabinetStatus(token);
  const component = cabinetResponse?.component;

  const isRegistrationUpdate =
    component === CabinetStatuses.registration_update;
  const isApplication = component === CabinetStatuses.application;
  const isInfo = component === CabinetStatuses.info;
  const isSignAgreement = component === CabinetStatuses.sign;
  const isDeal = component === CabinetStatuses.deal;
  const isProlongation = component === CabinetStatuses.prolongation;
  const isRepeat = component === CabinetStatuses.repeat;
  const isBlocking = component === CabinetStatuses.blocking;

  const isAuthRedirect =
    !isRegistrationUpdate &&
    !isApplication &&
    !isInfo &&
    !isSignAgreement &&
    !isDeal &&
    !isProlongation &&
    !isRepeat &&
    !isBlocking;

  if (isAuthRedirect) {
    return replace('/auth', { status: 301 });
  }

  return null;
};
